import type { HelpFile } from '../../types/help'
import { FormLayoutListPageTestIds } from '../../../testids/FormLayoutListPageTestIds'

export const formLayoutListPageHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [FormLayoutListPageTestIds.formLayoutListPage]: 'Übersicht aller Formular-Layouts. Ein Layout legt fest, welche Attribute in welcher Reihenfolge auf einem Bildschirm erscheinen.',
    [FormLayoutListPageTestIds.colKey]: 'Stabiler Schlüssel des Formular-Layouts, über den der Code es referenziert.',
    [FormLayoutListPageTestIds.colUseCase]: 'Der Bildschirm oder Workflow, für den dieses Layout verwendet wird, z. B. Partei anlegen oder Identität bearbeiten.',
    [FormLayoutListPageTestIds.colFormFields]: null,
    [FormLayoutListPageTestIds.colStatus]: 'Ob dieses Layout aktiv, inaktiv oder Standard für seinen Anwendungsfall ist.',
    [FormLayoutListPageTestIds.badgeStatusActive]: 'Layout ist aktiv und kann von Aufrufern, die es explizit auswählen, verwendet werden.',
    [FormLayoutListPageTestIds.badgeStatusDefault]: 'Layout ist Standard für seinen Anwendungsfall und wird genutzt, wenn keine andere Auswahl getroffen wird.',
    [FormLayoutListPageTestIds.badgeStatusInactive]: 'Layout ist inaktiv und wird nicht gerendert.',
  },
}
